import { IoAddCircle } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { Button, Card, Label } from "reactstrap";
import illustratorImg from "../../assets/illustator.jpg";
const ImageUploadInput = ({ value, setValue, id }) => {
  return (
    <Label
      style={{ borderRadius: "13.48px" }}
      className="m-0  d-flex full-width"
      htmlFor={id}
    >
      <Card
        style={{
          background: "rgba(241, 241, 241, 1)",
          minHeight: "150px",
          borderRadius: "18.19px",
        }}
        className="border-dashed-primary-blue p-0  full-width position-relative d-flex align-items-center justify-content-center full-width"
      >
        {value !== null && (
          <Button
            onClick={(e) => {
              e?.preventDefault();
              setValue(null);
            }}
            className="bg-danger p-0 full-rounded  position-absolute border-none d-flex align-items-center justify-content-center"
            style={{
              height: 30,
              width: 30,
              top: "-15px",
              right: "-14px",
              zIndex: 3,
            }}
          >
            <RxCross2 size={15} color="white" strokeWidth={"1px"} />
          </Button>
        )}
        {value !== null ? (
          <img
            height={150}
            src={
              value instanceof File
                ? URL.createObjectURL(value)
                : typeof value === "string"
                ? value
                : Array.isArray(value) && typeof value[0] === "string"
                ? value[0]
                : illustratorImg
            }
            style={{ borderRadius: "18.19px" }}
            className="full-width object-fit-contain"
          />
        ) : (
          <div className="color-primary-blue">
            <IoAddCircle size={30} />
          </div>
        )}
        <input
          onChange={(e) => setValue(e?.target?.files[0])}
          className="d-none"
          type="file"
          id={id}
          accept="image/*"
        />
      </Card>
    </Label>
  );
};

export default ImageUploadInput;
